import { authHeader, BASE_URL, handleResponse } from '@helpers/api';

export const ifoodIntegrationService = {
    connectIntegration,
    disconnectIntegration,
    getMerchants,
    editProfile,
    getOrders,
};

function getMerchants() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/integrations/ifood/merchants`, requestOptions).then(handleResponse);
}

function connectIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/integrations/ifood/authorize`, requestOptions).then(handleResponse);
}

function disconnectIntegration() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/integrations/ifood/revoke-access`, requestOptions).then(handleResponse);
}

function editProfile(locationId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/ifood:connect`, requestOptions).then(
        handleResponse,
    );
}

function getOrders() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/integrations/ifood/orders`, requestOptions).then(handleResponse);
}
